import moment from 'moment';
import orderBy from 'lodash/orderBy';
import get from 'lodash/get';

const DATE_FORMAT = 'MM/DD/YYYY';

const getFormattedLotteryDate = (lotteryTime) => moment.unix(lotteryTime).utc().format(DATE_FORMAT);

export const getTimestampDate = (formattedDate) => (formattedDate ? moment.utc(formattedDate).format('x') : undefined);

export const getFormattedDate = (timestampInMilliseconds) =>
  timestampInMilliseconds ? moment.utc(timestampInMilliseconds).format(DATE_FORMAT) : undefined;

export const isActiveAnnouncement = (announcement, lotteryTime) => {
  const date = getFormattedLotteryDate(lotteryTime);
  const publishFrom = getFormattedDate(announcement.publishFrom);
  const publishTo = getFormattedDate(announcement.publishTo);
  return moment(date).isBetween(publishFrom, publishTo, 'day', '[]');
};

export const isArchivedAnnouncement = (announcement, lotteryTime) => {
  const date = getFormattedLotteryDate(lotteryTime);
  const publishTo = getFormattedDate(announcement.publishTo);
  return moment(date).isAfter(publishTo, 'day');
};

export const isScheduledAnnouncement = (announcement, lotteryTime) => {
  const date = getFormattedLotteryDate(lotteryTime);
  const publishFrom = getFormattedDate(announcement.publishFrom);
  return moment(date).isBefore(publishFrom, 'day');
};

const orderAnnouncements = (announcements, locale) =>
  orderBy(announcements, [(item) => (get(item, `fields.${locale}.pinned`) ? 0 : 1), 'publishFrom', 'id'], ['asc', 'desc', 'desc']);

export const getActiveAnnouncements = (announcements, lotteryTime, locale) => {
  const activeAnnouncement = announcements.filter((item) => isActiveAnnouncement(item, lotteryTime));
  return orderAnnouncements(activeAnnouncement, locale);
};

export const getArchivedAnnouncements = (announcements, lotteryTime, locale) => {
  const archivedAnnouncement = announcements.filter((item) => isArchivedAnnouncement(item, lotteryTime));
  return orderAnnouncements(archivedAnnouncement, locale);
};

export const getScheduledAnnouncements = (announcements, lotteryTime, locale) => {
  const scheduledAnnouncement = announcements.filter((item) => isScheduledAnnouncement(item, lotteryTime));
  return orderAnnouncements(scheduledAnnouncement, locale);
};

const togglePinValue = (items, index, locale) => {
  items[index].fields[locale.code].pinned = !items[index].fields[locale.code].pinned;
};

export const togglePinAnnouncement = (announcements, index, locale, locales) => {
  locales.forEach((localeItem) => togglePinValue(announcements, index, localeItem));
  return orderAnnouncements(announcements, locale);
};

export const deleteAnnouncement = (announcements, index) => {
  announcements.splice(index, 1);
  return announcements;
};

export const addAnnouncement = (announcements, announcement, locale) => {
  announcement = {
    ...announcement,
    publishFrom: parseInt(getTimestampDate(announcement.publishFrom), 10),
    publishTo: parseInt(getTimestampDate(announcement.publishTo), 10),
  };
  const newAnnouncements = [announcement, ...announcements];
  return orderAnnouncements(newAnnouncements, locale);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/announcements/utils.js